<template>
    <div class="top-menu-topitem">
        <div class="hover"></div>
        <slot>
            <a :href="url">{{name}}</a>
        </slot>
    </div>
</template>

<script>
export default {
    props: ["name", "url"],
    components: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-topitem {
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        align-content: center;
        position: relative;
        &:hover {
            cursor: pointer;
            background: none;
            //box-shadow: 0 3px 0 #6179E0;
            //z-index: 99999999;
            .hover {
                display: block;
            } 
        }
        .hover {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 32px;
            height: 3px;
            background: #6179E0;
            display: none;
        }
        a {
            text-decoration: none;
            color: #212529;
        }
    }
    
</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
